// Function to track PDP visits and fetch product data
async function trackPDPVisit() {
  const currentURL = window.location.pathname;
 

  
  let pdpVisits = JSON.parse(localStorage.getItem('pdpVisits')) || [];

   if(!currentURL.includes('/products/')) {
     window.recentlyViewed = pdpVisits;
     return;
   };
  
  const productData =  await fetchProductData(currentURL);

  pdpVisits.unshift(productData);

  if (pdpVisits.length > 4) {
    pdpVisits = pdpVisits.slice(0, 4);
  }

  localStorage.setItem('pdpVisits', JSON.stringify(pdpVisits));

   // Store the product data in the window object
    if (!window.recentlyViewed) {
      window.recentlyViewed = JSON.parse(localStorage.getItem('pdpVisits'));
    }

   
}

// Function to fetch product data
async function fetchProductData(url) {
  try {
    // Assume the product handle can be extracted from the URL
    const productHandle = url.split('/').pop();
    console.log('productHandle', productHandle);
    // Fetch the product data from Shopify
    const response = await fetch(`/products/${productHandle}.js`);
    if (!response.ok) {
      throw new Error(`Error fetching product data: ${response.statusText}`);
    }

    const productData = await response.json();

      return productData;

    console.log('Product data fetched and stored:', productData);
  } catch (error) {
    console.log('Failed to fetch product data:', error);
  }
}

// Call the function to track the PDP visit and fetch product data
trackPDPVisit();